/**
 * Devuelve "hace X [días] Y horas y Z minutos" / "en ..."
 * Muestra "días" únicamente si han pasado más de 24 horas.
 * @param {string|Date|number} input - Fecha ISO/Z, Date o timestamp (ms).
 * @returns {string}
 */
export function tiempoDesde(input) {
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return "fecha inválida";

  let diff = Date.now() - d.getTime();
  const future = diff < 0;
  diff = Math.abs(diff);

  const totalMin = Math.floor(diff / 60000);
  if (totalMin === 0) return "ahora mismo";

  const days = Math.floor(totalMin / (60 * 24)); // días solo si > 0
  const hours = Math.floor((totalMin % (60 * 24)) / 60);
  const minutes = totalMin % 60;

  const parts = [];

  if (days > 0) parts.push(`${days} ${days === 1 ? "día" : "días"}`);
  // Si no hay días, se comporta como antes: solo horas y minutos
  if (hours > 0 && days === 0) parts.push(`${hours} ${hours === 1 ? "hora" : "horas"}`);
  if (minutes > 0 && days === 0) parts.push(`${minutes} ${minutes === 1 ? "minuto" : "minutos"}`);

  const texto = parts.join(" y ");
  return future ? `en ${texto}` : `hace ${texto}`;
}

// Mapa de etiquetas (puedes ajustar los textos a tu gusto)
const ORDER_LABELS = {
  pending: "Tu pedido ha sido recibido",
  inPreparation: "Estamos preparando tu pedido",
  prepared: "Tu pedido está listo",
  inDelivery: "Tu pedido está en camino",
  delivered: "Tu pedido ha sido entregado",
  notDelivered: "No se pudo entregar tu pedido",
  canceled: "Tu pedido ha sido cancelado",
  abandoned: "Tu pedido ha sido abandonado",
  returned: "Tu pedido ha sido devuelto",
};

// “Camino” a renderizar por estado actual
const ORDER_PATHS = {
  pending: ["pending"],
  inPreparation: ["pending", "inPreparation"],
  prepared: ["pending", "inPreparation", "prepared"],
  inDelivery: ["pending", "inPreparation", "prepared", "inDelivery"],
  delivered: ["pending", "inPreparation", "prepared", "inDelivery", "delivered"],
  notDelivered: ["pending", "inPreparation", "prepared", "inDelivery", "notDelivered"],
  canceled: ["pending", "canceled"], // cancelado temprano
  abandoned: ["pending", "abandoned"], // carrito/pedido abandonado
  returned: ["pending", "inPreparation", "prepared", "inDelivery", "delivered", "returned"],
};

/**
 * Genera los <li> del timeline según el estado actual.
 * @param {("pending"|"inPreparation"|"prepared"|"inDelivery"|"delivered"|"notDelivered"|"canceled"|"abandoned"|"returned")} status
 * @param {string|Date|number} updatedAt - fecha del estado actual (para tiempoDesde)
 * @param {(d:any)=>string} [formatTime=tiempoDesde] - formateador de tiempo (opcional)
 * @returns {React.ReactNode[]} Array de <li> listos para renderizar
 */
export function renderOrderTimeline(status, updatedAt, formatTime = tiempoDesde, fulfillmentType) {
  if (status === "cancelled") status = "canceled";
  const path = (ORDER_PATHS[status] || [status]).filter(step => !(fulfillmentType === "pickup" && status === "delivered" && step === "inDelivery"));

  return path.map((step) => (
    <li key={step}>
      <div className="circleRounded">
        <div className="circle"></div>
      </div>
      <div className="event">
        <div className="event-name">{ORDER_LABELS[step] || step}</div>

        {/* Solo el estado actual muestra la fecha */}
        {step === status && updatedAt != null && Number.isFinite(new Date(updatedAt).getTime()) && <div className="event-date">{formatTime(updatedAt)}</div>}
      </div>
    </li>
  ));
}
